module.exports = ".pdf-frame {\n  height: 65vh;\n  display: block;\n  border: none;\n  width: 100%; }\n\n@media screen and (max-height: 900px) {\n  .pdf-frame {\n    height: 60vh; } }\n\n@media screen and (max-height: 700px) {\n  .pdf-frame {\n    height: 55vh; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/lbpa-edoc/lbpa-edoc.component.scss
// module id = /bRF
// module chunks = 1